import { Event } from "utils/Event";

export class Rpc {

    public static readonly onFetchingStateChanged: Event<boolean> = new Event<boolean>();

    private static _inProgressCount: number = 0;

    public static get isFetching(): boolean {
        return this._inProgressCount > 0;
    }

    public static GET<$Response>(url: string): Promise<$Response> {
        return this.fetch(url, "GET");
    }

    public static POST<$Response>(url: string, data: {}): Promise<$Response> {
        return this.fetch(url, "POST", data);
    }

    private static handleFetchStart() {
        var isAlreadyStarted = this.isFetching;
        this._inProgressCount++;
        if (!isAlreadyStarted) {
            this.onFetchingStateChanged.fire(true);
        }
    }

    private static handleFetchEnd() {
        this._inProgressCount--;
        if (!this.isFetching) {
            this.onFetchingStateChanged.fire(false);
        }
    }

    public static fetch<$Resp>(url: string, method: TRpcMethod, data?: {}): Promise<$Resp> {
        var bodyStr = null;
        if (data != null && method == "POST") {
            bodyStr = JSON.stringify(data);
        }
        return new Promise((resolve, reject) => {
            this.handleFetchStart();
            fetch(url, {
                method: method,
                body: bodyStr,
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: "include",
            })
                .then(async (resp) => {
                    try {
                        var json = await resp.json();
                        if (!resp.ok) {
                            if (json.fieldErrors == null) {
                                json.fieldErrors = {};
                            }
                            var ex = new ApiException(json.message, json.code, json.fieldErrors);
                            reject(ex);
                            return;
                        }

                        resolve(json as $Resp);
                    } finally {
                        this.handleFetchEnd();
                    }
                })
                .catch((err) => {
                    try {
                        var ex = new ApiException("" + err, -1, null);
                        reject(ex);
                    } finally {
                        this.handleFetchEnd();
                    }
                });
        });
    }

    private constructor() { }

}

export class ApiException extends Error {
    public readonly code: number;
    public readonly fieldErrors: { [fieldName: string]: string };

    public constructor(message: string, code: number, fieldErrors: {[fieldName: string]: string}) {
        super(message);
        this.code = code;
        this.fieldErrors = fieldErrors;
    }
}

export type TRpcMethod = "GET" | "POST";